export default "__VITE_ASSET__BC9AKKX6__"